import { useEffect, useRef } from "react";

import "./ScrollDown.scss";

import arrowDownImg from "../../assets/img/arrow_down.svg";

export default function ScrollDown() {
  const scrollDownEl = useRef(null);
  let showTimeout;

  useEffect(() => {
    initScrolldown();

    document.addEventListener("scroll", () => resetTimeout());

    return () => {
      document.removeEventListener("scroll", () => resetTimeout());
    };
  }, []);

  const initScrolldown = () => {
    showTimeout = setTimeout(showScrolldown, 2000);
  };

  const showScrolldown = () => {
    scrollDownEl.current.classList.remove("hidden");
  };

  const hideScrolldown = () => {
    scrollDownEl.current.classList.add("hidden");
  };

  const resetTimeout = () => {
    hideScrolldown();
    clearTimeout(showTimeout);
    initScrolldown();
  };

  return (
    <div className="scrolldown">
      <div className="scrolldown__wrapper hidden" ref={scrollDownEl}>
        <div className="scrolldown__text">Scroll down to continue</div>
        <div className="scrolldown__icon">
          <img src={arrowDownImg} alt="Down arrow" />
        </div>
      </div>
    </div>
  );
}
